import { render, staticRenderFns } from "./Content.vue?vue&type=template&id=355b31ac&scoped=true&lang=pug"
import script from "./Content.vue?vue&type=script&lang=js"
export * from "./Content.vue?vue&type=script&lang=js"
import style0 from "./Content.styl?vue&type=style&index=0&id=355b31ac&prod&lang=stylus&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "355b31ac",
  null
  
)

export default component.exports